import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    tagContainer: {
        display: 'flex',
        flexWrap: "wrap",
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "center"
    },
    tag: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
        borderColor: theme.palette.secondary.main,
        borderStyle: "solid",
        borderRadius: 10,
        borderWidth: 1,
        padding: 2,
        margin: 2,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
}));

export {useStyles};